import styled, { css } from 'styled-components';
import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';
import off from './images/check-off.svg'
import on from './images/check-on.svg'

export const Top = styled.div`
  position: relative;
  box-shadow: 0 6.3px 11.4px 0 rgba(0, 0, 0, 0.11);
  z-index: 1;

  > div.youtube-wrap {
    width: 100%;
    height: 33.5%;
    text-align: center;
    position: absolute;
    bottom: 3%;

    > div {
      width: 100%;
      height: 100%;
    }

    iframe {
      width: 90%;
      height: 100%;
    }
  }
`;

export const Content = styled.div`
  position: relative;
  box-shadow: 0 6.3px 11.4px 0 rgba(0, 0, 0, 0.11);

  > div.q1 {
    position: absolute;
    top: 53%;
    left: 6%;
    right: 6%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > img {
      width: 18%;
      height: 18%;
    }
  }

`;

export const ButtonWrap = styled.div`
  position: absolute;
  width: 42%;
  top: 73%;
  left: 29%;
`;

export const AgreeWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 6%;
  background-color: #e5ebfd;

  > div + div, > ul + div {
    margin-top: 4%;
  }
`;

export const LabelWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  svg {
    ${({ isCheck }) => isCheck ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const Label = styled.label`
  display: contents;
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #0066ec;
  letter-spacing: -1px;
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  background: #fff url(${off}) center center no-repeat;

  &:checked {
    background-image: url(${on});
  }

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const Ul = styled.ul`
  margin-top: 2%;

  > li {
    padding-left: 2%;

    ${media.pcLarge`
      font-size: 16px;
    `}

    ${media.tabletLarge`
      font-size: 16px;
    `}

    ${media.tabletSmall`
      font-size: 16px;
    `}

    ${media.mobileLarge`
      font-size: 12px;
    `}

    ${media.mobileMid`
      font-size: 12px;
    `}

    ${media.mobileSmall`
      font-size: 12px;
    `}

    ${media.pcLarge`
      line-height: 28px;
    `}

    ${media.tabletLarge`
      line-height: 28px;
    `}

    ${media.tabletSmall`
      line-height: 28px;
    `}

    ${media.mobileLarge`
      line-height: 20px;
    `}

    ${media.mobileMid`
      line-height: 20px;
    `}

    ${media.mobileSmall`
      line-height: 20px;
    `}

    color: #797a7c;
    letter-spacing: -1px;
  }
`;

export const Overlay = styled.div`
  width: 100%;
  max-width: 640px;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  position: fixed;
  top: 0;
  
  > img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
`;


export const ArrowWrap = styled.div`
  margin-left: 2%;
`;